<div class="detail" [class.visible]="view">
  <header>
    <div class="close" (click)="close()"></div>
    <h2 *ngIf="!view">Bulk Edit</h2>
    <h2 *ngIf="view">Bulk Edit — {{listName}}</h2>
  </header>
  <div class="detail-body">
    <section>
      <div *ngIf="!view && errors.length === 0" class="loading">Loading . . .</div>

      <div *ngIf="view" class="view-fields">
        <div class="bulk-summary">
          Updating <b>{{memberCount}}</b> {{memberCount === 1 ? 'item' : 'items'}} in <b>{{listName}}</b>.
          <span class="hint">Untouched fields are preserved. Only fields you edit will be applied.</span>
        </div>

        <ng-container *ngFor="let field of view.fields">
          <div class="field" *ngIf="isFieldVisible(field)"
               [class.dirty]="dirtyPaths.has(field.path)"
               [class.various]="isVarious(field)">
            <label>
              <span *ngIf="field.locationSpecific && activeLocation?._id">{{activeLocation.name}} </span>{{field.name}}<span *ngIf="field.required && isFieldEditable(field)" class="required">*</span>
              <span *ngIf="dirtyPaths.has(field.path)" class="revert-btn" (click)="revertField(field)" title="Revert">Revert</span>
            </label>

            <div *ngIf="field.locationSpecific && (!activeLocation || !activeLocation._id)" class="value location-hint">
              Select a location to edit this field.
            </div>

            <!-- Image: bulk upload not supported -->
            <div *ngIf="field.type === 'image' && isFieldEditable(field)" class="value muted">
              Image fields cannot be bulk-updated. Edit items individually.
            </div>

            <ng-container *ngIf="isFieldEditable(field) && field.type !== 'image'">

              <!-- ── Boolean (needs explicit "Set value" affordance when various) ── -->
              <ng-container *ngIf="field.type === 'boolean'">
                <div *ngIf="isVarious(field)" class="bool-various">
                  <span class="various-label">Various Values</span>
                  <span class="set-value-btn" (click)="setBoolean(field, false)">Set: Off</span>
                  <span class="set-value-btn" (click)="setBoolean(field, true)">Set: On</span>
                </div>
                <app-toggle *ngIf="!isVarious(field)"
                  [checked]="editValues[field.path]"
                  (valueChanged)="toggleBoolean(field)">
                </app-toggle>
              </ng-container>

              <!-- ── String array ── -->
              <ng-container *ngIf="isArrayField(field) && field.type === 'string'">
                <div class="chips">
                  <div class="chip" *ngFor="let val of editValues[field.path]; let i = index">
                    {{val}}<div class="chip-remove" (click)="removeArrayValue(field, i)"></div>
                  </div>
                </div>
                <input *ngIf="editValues[field.path]?.length < field.limit"
                       type="text"
                       [class.various-input]="isVarious(field)"
                       [placeholder]="isVarious(field) ? 'Various Values' : ''"
                       [(ngModel)]="arrayInputValues[field.path]"
                       (keydown)="onArrayStringKeydown($event, field)" />
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- ── String single ── -->
              <input *ngIf="!isArrayField(field) && field.type === 'string'"
                     type="text"
                     [class.various-input]="isVarious(field)"
                     [placeholder]="isVarious(field) ? 'Various Values' : ''"
                     [ngModel]="editValues[field.path]"
                     (ngModelChange)="editValues[field.path] = $event; markDirty(field)" />

              <!-- ── Number ── -->
              <input *ngIf="!isArrayField(field) && field.type === 'number'"
                     type="number"
                     [class.various-input]="isVarious(field)"
                     [placeholder]="isVarious(field) ? 'Various Values' : ''"
                     [ngModel]="editValues[field.path]"
                     (ngModelChange)="editValues[field.path] = $event; markDirty(field)" />

              <!-- ── Currency (advancedPrice bulk-edits the standard price) ── -->
              <input *ngIf="!isArrayField(field) && (field.type === 'currency' || field.type === 'advancedPrice')"
                     type="number"
                     step="0.01"
                     [class.various-input]="isVarious(field)"
                     [placeholder]="isVarious(field) ? 'Various Values' : ''"
                     [ngModel]="editValues[field.path]"
                     (ngModelChange)="editValues[field.path] = $event; markDirty(field)" />

              <!-- ── DateTime ── -->
              <ng-container *ngIf="!isArrayField(field) && field.type === 'dateTime' && dateTimeSettings[field.path]">
                <div *ngIf="isVarious(field)" class="various-hint">Various Values — pick a date to apply to all items</div>
                <app-filter-date-range
                  [rangeConfig]="dateTimeSettings[field.path]"
                  (rangeChanged)="markDirty(field)">
                </app-filter-date-range>
              </ng-container>

              <!-- ── SourceCollection array: add/remove deltas when values vary across the list ── -->
              <ng-container *ngIf="isArrayField(field) && field.type === 'sourceCollection' && isDeltaField(field)">
                <div class="various-hint">
                  Various Values — × removes a value from every item, + applies a partial value to every item,
                  and anything you pick below is added to every item.
                </div>
                <div class="chips stacked">
                  <div class="chip" *ngFor="let entry of arrayValueCounts[field.path]"
                       [class.partial]="chipState(field, entry) === 'partial'"
                       [class.removed]="chipState(field, entry) === 'removed'"
                       [class.added]="chipState(field, entry) === 'added'">
                    <span class="chip-label">{{entry.display}}</span>
                    <span *ngIf="chipState(field, entry) === 'partial'" class="chip-count">{{entry.count}} of {{memberCount}}</span>
                    <span *ngIf="chipState(field, entry) === 'added'" class="chip-count">all</span>
                    <ng-container [ngSwitch]="chipState(field, entry)">
                      <ng-container *ngSwitchCase="'partial'">
                        <div class="chip-add" title="Add to all items" (click)="queueAdd(field, entry)"></div>
                        <div class="chip-remove" title="Remove from all items" (click)="queueRemove(field, entry.value)"></div>
                      </ng-container>
                      <div *ngSwitchCase="'full'" class="chip-remove" title="Remove from all items" (click)="queueRemove(field, entry.value)"></div>
                      <div *ngSwitchCase="'added'" class="chip-undo" (click)="undoAdd(field, entry.value)">Undo</div>
                      <div *ngSwitchCase="'removed'" class="chip-undo" (click)="undoRemove(field, entry.value)">Undo</div>
                    </ng-container>
                  </div>
                  <div class="chip added" *ngFor="let entry of newDeltaValues(field)">
                    <span class="chip-label">{{entry.display}}</span><span class="chip-count">all</span>
                    <div class="chip-undo" (click)="undoAdd(field, entry.value)">Undo</div>
                  </div>
                </div>
                <app-source-select
                  [viewKey]="viewKey"
                  [path]="field.path"
                  [locationId]="activeLocation?._id || ''"
                  [documentId]="null"
                  [documentValues]="editValues"
                  [ignoreUnresolvedRefs]="true"
                  [displayValue]="''"
                  [excludeValues]="deltaExcludeValues(field)"
                  (selectionChange)="queueAdd(field, $event)">
                </app-source-select>
                <div class="limit-count">Limit {{field.limit}} per item — items that would exceed it are skipped and reported.</div>
                <div class="mode-link" (click)="setReplaceMode(field, true)">Replace all values instead</div>
              </ng-container>

              <!-- ── SourceCollection array: whole-array replace ── -->
              <ng-container *ngIf="isArrayField(field) && field.type === 'sourceCollection' && !isDeltaField(field)">
                <div *ngIf="!isVarious(field) && !dirtyPaths.has(field.path)" class="current-value">
                  <span *ngIf="displayValues[field.path]?.length">Current:</span>
                  <span *ngIf="!displayValues[field.path]?.length" class="muted">Current: <i>(none)</i></span>
                </div>
                <div *ngIf="dirtyPaths.has(field.path)" class="current-value dirty">New value:</div>
                <div class="chips stacked">
                  <div class="chip" *ngFor="let item of displayValues[field.path]; let i = index">
                    {{item.display}}<div class="chip-remove" (click)="removeSourceValue(field, i)"></div>
                  </div>
                  <span *ngIf="isVarious(field)" class="various-chip">Various Values</span>
                </div>
                <app-source-select
                  *ngIf="editValues[field.path]?.length < field.limit"
                  [viewKey]="viewKey"
                  [path]="field.path"
                  [locationId]="activeLocation?._id || ''"
                  [documentId]="null"
                  [documentValues]="editValues"
                  [ignoreUnresolvedRefs]="true"
                  [displayValue]="''"
                  [excludeValues]="editValues[field.path] || []"
                  (selectionChange)="addSourceValue(field, $event)">
                </app-source-select>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
                <div *ngIf="replaceMode[field.path]" class="various-hint">Saving will replace this field on every item.</div>
                <div *ngIf="replaceMode[field.path]" class="mode-link" (click)="setReplaceMode(field, false)">Back to add / remove</div>
              </ng-container>

              <!-- ── SourceCollection single ── -->
              <ng-container *ngIf="!isArrayField(field) && field.type === 'sourceCollection'">
                <div *ngIf="isVarious(field)" class="various-hint">Various Values — pick one to apply to all items</div>
                <div *ngIf="!isVarious(field) && !dirtyPaths.has(field.path) && editValues[field.path]" class="current-value">
                  Current: <b>{{displayValues[field.path] || editValues[field.path]}}</b>
                </div>
                <div *ngIf="dirtyPaths.has(field.path) && displayValues[field.path]" class="current-value dirty">
                  New value: <b>{{displayValues[field.path]}}</b>
                </div>
                <app-source-select
                  [viewKey]="viewKey"
                  [path]="field.path"
                  [locationId]="activeLocation?._id || ''"
                  [documentId]="null"
                  [documentValues]="editValues"
                  [ignoreUnresolvedRefs]="true"
                  [displayValue]="isVarious(field) ? '' : displayValues[field.path]"
                  (selectionChange)="onSourceSelectionChange(field, $event)">
                </app-source-select>
              </ng-container>

              <!-- ── Address array ── -->
              <ng-container *ngIf="isArrayField(field) && field.type === 'address'">
                <div *ngIf="isVarious(field) && !dirtyPaths.has(field.path)" class="various-hint">
                  Various Values — adding addresses here will replace the list on every item.
                </div>
                <div class="address-list">
                  <div class="address-card" *ngFor="let addr of editValues[field.path]; let i = index">
                    <div class="address-card-header">
                      <span>Address {{i + 1}}</span>
                      <div class="chip-remove" (click)="removeAddress(field, i)"></div>
                    </div>
                    <input type="text" placeholder="Street Address" [(ngModel)]="addr.streetAddress" (ngModelChange)="markDirty(field)" />
                    <input type="text" placeholder="Address Ext." [(ngModel)]="addr.streetAddressExt" (ngModelChange)="markDirty(field)" />
                    <input type="text" placeholder="City" [(ngModel)]="addr.addressLocality" (ngModelChange)="markDirty(field)" />
                    <div class="address-row">
                      <select [(ngModel)]="addr.addressRegion" (ngModelChange)="markDirty(field)">
                        <option value="" disabled selected>State</option>
                        <option *ngFor="let state of states" [value]="state.key">{{state.name}}</option>
                      </select>
                      <input type="text" placeholder="Zip" [(ngModel)]="addr.postalCode" (ngModelChange)="markDirty(field)" />
                    </div>
                  </div>
                </div>
                <div *ngIf="!field.limit || editValues[field.path]?.length < field.limit" class="address-add" (click)="addAddress(field)">+ Add Address</div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- ── Address single ── -->
              <ng-container *ngIf="!isArrayField(field) && field.type === 'address'">
                <div *ngIf="isVarious(field)" class="various-hint">Various Values — editing here will apply to all items.</div>
                <div class="address-card">
                  <input type="text" placeholder="Street Address" [(ngModel)]="editValues[field.path].streetAddress" (ngModelChange)="markDirty(field)" />
                  <input type="text" placeholder="Address Ext." [(ngModel)]="editValues[field.path].streetAddressExt" (ngModelChange)="markDirty(field)" />
                  <input type="text" placeholder="City" [(ngModel)]="editValues[field.path].addressLocality" (ngModelChange)="markDirty(field)" />
                  <div class="address-row">
                    <select [(ngModel)]="editValues[field.path].addressRegion" (ngModelChange)="markDirty(field)">
                      <option value="" disabled selected>State</option>
                      <option *ngFor="let state of states" [value]="state.key">{{state.name}}</option>
                    </select>
                    <input type="text" placeholder="Zip" [(ngModel)]="editValues[field.path].postalCode" (ngModelChange)="markDirty(field)" />
                  </div>
                </div>
              </ng-container>

              <!-- ── Rich text ── -->
              <ng-container *ngIf="field.type === 'richText'">
                <div *ngIf="isVarious(field)" class="various-hint">Various Values — editing here will apply to all items.</div>
                <div class="rt-toolbar" (mousedown)="$event.preventDefault()">
                  <div class="rt-btn" [class.active]="rtState[field.path]?.bold" (mousedown)="rtExec($event, field, 'bold')"><b>B</b></div>
                  <div class="rt-btn" [class.active]="rtState[field.path]?.italic" (mousedown)="rtExec($event, field, 'italic')"><i>I</i></div>
                  <div class="rt-btn" [class.active]="rtState[field.path]?.underline" (mousedown)="rtExec($event, field, 'underline')"><u>U</u></div>
                  <div class="rt-sep"></div>
                  <div class="rt-btn-dropdown">
                    <div class="rt-btn" (mousedown)="toggleRtDropdown($event, field, 'fontSize')" title="Font Size">
                      <span class="rt-size-lg">A</span><span class="rt-size-sm">A</span>
                    </div>
                    <div *ngIf="rtDropdown[field.path] === 'fontSize'" class="rt-dropdown">
                      <div *ngFor="let size of rtFontSizes" class="rt-dropdown-item" (mousedown)="rtSetFontSize($event, field, size.value)">{{size.label}}</div>
                    </div>
                  </div>
                  <div class="rt-btn-dropdown">
                    <div class="rt-btn" (mousedown)="toggleRtDropdown($event, field, 'fontColor')" title="Font Color">
                      <span class="rt-color-icon">A</span>
                    </div>
                    <div *ngIf="rtDropdown[field.path] === 'fontColor'" class="rt-dropdown rt-color-grid">
                      <div *ngFor="let color of rtColors" class="rt-color-swatch" [style.background-color]="color" (mousedown)="rtSetColor($event, field, color)"></div>
                    </div>
                  </div>
                  <div class="rt-sep"></div>
                  <div class="rt-btn" (mousedown)="rtStartLink($event, field)" title="Link">
                    <svg width="14" height="14" viewBox="0 0 14 14"><path d="M5.5 8.5L8.5 5.5M4 9l-1 1a2.12 2.12 0 003 3l1-1M10 5l1-1a2.12 2.12 0 00-3-3L7 2" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>
                  </div>
                </div>
                <div *ngIf="rtLinkInput[field.path]?.active" class="rt-link-bar">
                  <input type="text" placeholder="https://" [(ngModel)]="rtLinkInput[field.path].url" (keydown.enter)="rtApplyLink(field)" />
                  <div class="rt-link-apply" (click)="rtApplyLink(field)">Apply</div>
                  <div class="rt-link-cancel" (click)="rtCancelLink(field)">Cancel</div>
                </div>
                <div class="rt-editor" contenteditable="true"
                     [attr.data-path]="field.path"
                     (input)="onRtInput($event, field)"
                     (paste)="onRtPaste($event, field)"
                     (mouseup)="updateRtState(field)"
                     (keyup)="updateRtState(field)">
                </div>
              </ng-container>

            </ng-container>
          </div>
        </ng-container>

        <div *ngIf="canUpdate && errors.length > 0" class="error-list">
          <div *ngFor="let error of errors" class="error">{{error}}</div>
        </div>

        <div *ngIf="canUpdate" class="buttons">
          <div class="button green" [class.disabled]="saving || deleting || dirtyPaths.size === 0" (click)="save()">
            {{saving ? 'Saving…' : 'Save'}}
          </div>
          <div class="button red" (click)="close()">Cancel</div>
          <div *ngIf="canDelete && deletable" class="button red" [class.disabled]="deleting || saving"
               (click)="deleteAll()">
            {{deleting ? 'Deleting…' : 'Delete All'}}
          </div>
        </div>
      </div>

      <div *ngIf="!view && errors.length > 0" class="view-fields">
        <div *ngFor="let error of errors" class="error" style="padding: 16px;">{{error}}</div>
      </div>
    </section>
  </div>
</div>
